var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAddWidgetFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 136,
    viewBox: "0 0 144 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 135.5C105.277 135.5 135.5 105.277 135.5 68C135.5 30.7231 105.277 0.5 68 0.5C30.7231 0.5 0.5 30.7231 0.5 68C0.5 105.277 30.7231 135.5 68 135.5Z",
    fill: "#F7F9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 25.3201C119.155 25.3201 120.5 23.7624 120.5 21.8458C120.5 19.9291 119.155 18.3715 117.5 18.3715C115.845 18.3715 114.5 19.9291 114.5 21.8458C114.5 23.7624 115.845 25.3201 117.5 25.3201Z",
    fill: "#DEEBF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.875 18.3715H140.125C141.987 18.3715 143.5 19.9291 143.5 21.8458C143.5 23.7624 141.987 25.3201 140.125 25.3201H128.875C127.013 25.3201 125.5 23.7624 125.5 21.8458C125.5 19.9291 127.013 18.3715 128.875 18.3715Z",
    fill: "#EFF5FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.064 126.819C38.6719 126.597 39.3139 126.302 39.8082 125.868C40.3934 125.357 40.632 124.701 40.7911 124.011C40.9956 123.121 41.0808 122.176 41.3308 121.286C41.4217 120.953 41.5978 120.831 41.6774 120.775C41.8705 120.636 42.0637 120.597 42.2455 120.614C42.4614 120.63 42.7625 120.714 42.9557 121.092C42.9841 121.147 43.0182 121.225 43.0466 121.342C43.0636 121.425 43.075 121.681 43.0977 121.787C43.1432 122.048 43.1829 122.31 43.2227 122.571C43.3477 123.444 43.4159 124.184 43.8079 124.984C44.3362 126.074 44.8646 126.736 45.5862 127.031C46.2793 127.314 47.1144 127.264 48.1769 127.036C48.2791 127.008 48.3757 126.992 48.478 126.969C48.9439 126.886 49.3927 127.203 49.4836 127.681C49.5745 128.159 49.2791 128.627 48.8132 128.732C48.7166 128.754 48.62 128.777 48.5291 128.793C47.0917 129.16 45.4328 130.467 44.4669 131.607C44.1715 131.957 43.734 132.947 43.2909 133.576C42.9614 134.037 42.5921 134.343 42.2853 134.454C42.0751 134.526 41.9046 134.515 41.7569 134.476C41.5467 134.421 41.3706 134.304 41.2399 134.121C41.166 134.02 41.0979 133.881 41.0694 133.709C41.0524 133.626 41.0524 133.414 41.0524 133.314C40.9615 132.992 40.8536 132.68 40.7683 132.358C40.5752 131.585 40.2002 131.095 39.7514 130.45C39.3309 129.844 38.8821 129.466 38.2174 129.16C38.1322 129.138 37.439 128.966 37.1947 128.866C36.8368 128.721 36.6664 128.471 36.6039 128.337C36.4959 128.115 36.4902 127.915 36.5073 127.754C36.5357 127.509 36.6436 127.303 36.8311 127.136C36.9448 127.031 37.1209 126.931 37.3538 126.881C37.5356 126.842 38.0072 126.819 38.0754 126.819H38.064ZM42.1375 125.563C42.1716 125.635 42.2057 125.713 42.2398 125.785C43.0125 127.381 43.8817 128.271 44.9328 128.699L44.9669 128.716C44.2624 129.255 43.6261 129.855 43.1375 130.434C42.9386 130.673 42.6716 131.168 42.3818 131.674C42.1205 130.801 41.6944 130.184 41.1603 129.411C40.7513 128.821 40.3195 128.376 39.7911 128.015C40.2002 127.798 40.5922 127.542 40.9331 127.248C41.5012 126.753 41.8762 126.185 42.1319 125.563H42.1375Z",
    fill: "#DEEBF7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 52.6001,
    width: 27.7333,
    height: 45.9333,
    rx: 2,
    fill: "#6FAEDA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.6667,
    y: 52.6001,
    width: 30.3333,
    height: 15.6,
    rx: 2,
    fill: "#6FAEDA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69.6667,
    y: 75.1333,
    width: 30.3333,
    height: 23.4,
    rx: 2,
    fill: "#6FAEDA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 38,
    width: 65,
    height: 10.67,
    rx: 2,
    fill: "#6FAEDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAddWidgetFound);
export default __webpack_public_path__ + "static/media/no-add-widget-found.7418bf9669c45190e025df7755e8e978.svg";
export { ForwardRef as ReactComponent };